import { UserRoundPenIcon, UserRoundPlusIcon } from '@buffer-mono/popcorn'

import { AssetThumbnail } from '~publish/components/AssetThumbnail'
import type { AssetThumbnailActionProps } from '~publish/components/AssetThumbnail'

import type { JSX } from 'react'

type TagToolButtonProps = Omit<
  AssetThumbnailActionProps,
  'label' | 'tooltip' | 'children'
> & {
  hasTags?: boolean
  label?: string
}

export const TagToolButton = ({
  hasTags = false,
  ...props
}: TagToolButtonProps): JSX.Element => {
  return (
    <AssetThumbnail.Action
      label={hasTags ? 'Edit User Tags' : 'Add User Tags'}
      tooltip={hasTags ? 'Edit User Tags' : 'Add User Tags'}
      {...props}
    >
      {hasTags ? <UserRoundPenIcon /> : <UserRoundPlusIcon />}
    </AssetThumbnail.Action>
  )
}
